const SUB_ROUTE_UPCOMING = `upcoming` as const;
const SUB_ROUTE_UPCOMING_DATE = `${SUB_ROUTE_UPCOMING}/:date` as const;
const SUB_ROUTE_LIVE = `live` as const;
const SUB_ROUTE_LEAGUES = `leagues` as const;
const SUB_ROUTE_OUTRIGHTS = `outrights` as const;

const SportsPageSubRoutes = {
	UPCOMING: [SUB_ROUTE_UPCOMING, SUB_ROUTE_UPCOMING_DATE],
	LIVE: SUB_ROUTE_LIVE,
	LEAGUES: SUB_ROUTE_LEAGUES,
	OUTRIGHTS: SUB_ROUTE_OUTRIGHTS
} as const;

export default SportsPageSubRoutes;
